import e from "../../utils/throwFormattedError/index.js";

const t = t => () => e(t), s = {
    log: !1,
    strictDev: !1,
    fetchForms: t("fetchForms function must be defined"),
    fetchFormResponses: t("fetchFormResponses function must be defined"),
    submitForm: t("submitForm function must be defined"),
    getFieldOverrides: () => null,
    shouldTruncateField: () => !1
}, o = new class {
    constructor() {
        Object.assign(this, s);
    }
    merge(e) {
        Object.assign(this, e);
    }
};

export { o as default };
//# sourceMappingURL=index.js.map
